<template>
	<div class="row form-group">
		<div class="col-md-12">
			<div class="d-flex justify-content-between">

				<label class="btn btn-sm btn-flat-info btn-outline-info" for="portfoliofile">{{
					$t('portfolioPhoto.uploadFile')
				}}</label>
				<input type="file" id="portfoliofile" ref="portfoliofile" style="display:none" multiple
					@change="onPortfolioFileChange" />
			</div>
			<table style="width:100%">
				<tr v-for="(portfolio, index) in model.attach_file_list" :key="index">
					<td style="width:20%">
						<FileView :resource="portfolio" @click="onViewFile(index)" />
					</td>
					<td style="width:25%" class="mt-2" :class="{ 'text-red': portfolio.invalid_file }">
						{{ portfolio.name }}
					</td>
					<td style="width:30%">
						<textarea class="ts-w-full ts-border form-control" rows="1" v-model="portfolio.remarks"
							:placeholder="$t('portfolioPhoto.remarks')"></textarea>
					</td>
					<td class="text-center" style="width:5%">
						<a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
							:cancel-text="$t('no')" @confirm="onRemoveFile(index, portfolio)">
							<a href="#" class="text-red" v-if="portfolio.progressing == 100">
								<i class="fa fa-times"></i>
							</a>
						</a-popconfirm>
					</td>
				</tr>
			</table>
		</div>
		<a-modal v-model="showModalFileView" :zIndex="1020" width="40%" :title="$t('portfolioPhoto.viewAttachment')"
			:footer="null" :maskClosable="false">
			<div class="ts-rounded-md group ts-relative ts-text-center ts-justify-between ts-items-center"
				style="height: 70vh;">
				<button @click.prevent="onMoveBack"
					class=" hover:ts-bg-gray-400 ts-absolute ts-align-middle ts-inline-block ts-left-0 ts-ml-3 ts-bg-gray-300 ts-px-4 ts-py-2 ts-rounded-md ts-items-center ts-justify-items-center"
					style="margin-top:280px;">
					<i class="fas fa-chevron-left ts-text-gray-700"></i>
				</button>
				<button @click.prevent="onMoveNext"
					class=" hover:ts-bg-gray-400 ts-absolute ts-right-0 ts-align-middle ts-inline-block ts-mr-3 ts-bg-gray-300 ts-px-4 ts-py-2 ts-rounded-md ts-items-center ts-justify-items-center"
					style="margin-top:280px;">
					<i class="fas fa-chevron-right ts-text-gray-700"></i>
				</button>
				<ViewModal :fileResource="currentViewFileResource" />
			</div>
		</a-modal>
	</div>
</template>
<script>
import httpClient from '@/http-client'
import { mapActions, mapState } from 'vuex'
import FileView from './components/file-viewer.vue'
import ViewModal from './components/view-modal.vue'
export default {
	name: 'portfolioAttachFile',
	components: {
		FileView,
		ViewModal
	},
	props: ['value'],
	data() {
		return {
			showModalFileView: false,
			currentViewIndex: 0,
			model: {},
			selectedPortfolioFiles: []
		}
	},
	created() {
		this.model = this.value
		this.setEdit()
	},
	computed: {
		...mapState('portfolioPhoto', ['edit_data']),
		isEdit() {
			return !_.isEmpty(this.edit_data) && this.edit_data !== undefined
		},
		currentViewFileResource() {
			if (this.model) {
				return this.model.attach_file_list[this.currentViewIndex]
			}
			return undefined
		}
	},
	methods: {
		...mapActions('portfolioPhoto', ['removeFileUploaded']),
		onPortfolioFileChange(e) {
			let files = e.target.files
			this.model.attach_file_list = [
				...this.model.attach_file_list,
				..._.map(files, file => ({
					id: 0,
					file_path: null,
					original_file_name: file.name,
					remarks: null,
					name: file.name,
					size: parseInt(file.size / 1024),
					size_text: parseInt(file.size / 1024) + 'KB',
					type: file.type,
					progressing: 0,
					invalid_file: this.validate(file),
					file: file,
					uploaded: false,
					storage_path: null
				}))
			]
			_.forEach(
				this.model.attach_file_list.filter(file => file.uploaded == false),
				(f, index) => {
					if (!this.validate(f.file)) {
						let frm = new FormData()
						frm.append('file', f.file)
						frm.append('file_type', 1)
						httpClient
							.post('/api/portfolio-photos/upload-files', frm, {
								onUploadProgress: el => {
									if (el.lengthComputable) {
										f.progressing = Math.round((el.loaded * 100) / el.total)
									}
								}
							})
							.then(response => {
								f.uploaded = true
								f.storage_path = response.data.file_path
								f.file_path = response.data.file_path
							})
							.catch(error => {
								this.$toasted.error(error.message)
							})
					}
				}
			)
		},
		validate(file) {
			let ALLOW_FILE = [
				'image/png',
				'image/jpeg',
				'application/pdf',
				'application/vnd.openxmlformats-officedocument.presentationml.presentation',
				'application/vnd.ms-powerpoint',
				'application/vnd.ms-excel',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/msword'
			]

			if (file.size > 10000000 * 10 || !ALLOW_FILE.includes(file.type)) {
				return true
			}

			return false
		},
		onRemoveFile(index, record) {
			if (record.id > 0) {
				this.removeFileUploaded({
					id: record.id,
					file_path: record.file_path
				})
			}
			let file_index = this.model.attach_file_list.indexOf(
				...this.model.attach_file_list.filter(
					f => f.file_path == record.file_path && f.id == record.id
				)
			)
			this.model.attach_file_list.splice(file_index, 1)
		},
		setEdit() {
			if (this.isEdit) {
				this.model.attach_file_list = this.edit_data.gallery_photos
					.map(el => ({
						name: el.original_file_name,
						size: 0,
						size_text: 0,
						type: el.mime_type,
						progressing: 100,
						invalid_file: false,
						file: el.file_path,
						file_path: el.file_path,
						uploaded: true,
						id: el.id,
						storage_path: el.storage_path,
						remarks: el.remarks
					}))
			}
		},
		onViewFile(index) {
			this.showModalFileView = true
			this.currentViewIndex = index
		},
		onMoveBack() {
			this.currentViewIndex =
				this.currentViewIndex - 1 > 0
					? this.currentViewIndex - 1
					: this.model.attach_file_list.length - 1
		},
		onMoveNext() {
			this.currentViewIndex =
				this.currentViewIndex + 1 <= this.model.attach_file_list.length - 1
					? this.currentViewIndex + 1
					: 0
		}
	}
}
</script>
  